// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__179FX","subheader":"ReorderModal_subheader__3FWIE","listWrap":"ReorderModal_listWrap__1tMF4"};